var _circle, _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictureicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 220,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 160,
    r: 160,
    fill: "#535F79"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 294,
    height: 294,
    rx: 147,
    fill: "#313D56"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_618_8480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.206 227.03L160.51 237.12L119.814 227.03C120.185 249.221 108.341 267.44 108.341 267.44C108.341 267.44 122.772 290.362 136.158 292.216H184.871C198.258 290.372 212.689 267.44 212.689 267.44C212.689 267.44 200.835 249.211 201.206 227.03Z",
    fill: "#7A89A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.028 159.453C223.215 155.94 217.298 163.893 217.483 172.578V102.142H160.5H103.518V172.587C103.703 163.893 97.7861 155.949 92.9725 159.462C88.1588 162.975 91.6738 175.544 94.6421 183.312C97.6006 191.08 96.4875 200.506 99.8268 201.248C103.156 201.99 103.898 195.373 103.898 195.373C103.898 195.373 112.881 224.658 122.616 233.831C133.835 244.39 153.841 250.059 160.5 250.059C167.159 250.059 187.176 244.39 198.385 233.831C208.129 224.658 217.102 195.373 217.102 195.373C217.102 195.373 217.844 201.99 221.174 201.248C224.503 200.506 223.39 191.08 226.359 183.312C229.327 175.544 232.842 162.966 228.028 159.453Z",
    fill: "#8E9FC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.973 284.448C265.629 278.974 221.271 265.927 212.484 262.648C211.302 262.209 209.964 262.59 209.203 263.595C189.909 289.074 160.49 284.819 160.49 284.819C160.49 284.819 131.071 289.074 111.778 263.595C111.016 262.59 109.678 262.209 108.497 262.648C99.7191 265.927 55.3514 278.974 46.0073 284.448C35.2962 290.733 31 307 31 307H160.5H290C290 307 285.704 290.733 274.973 284.448Z",
    fill: "#535F79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.5 110.827C160.5 110.827 156.985 112.125 146.626 110.827C136.266 109.529 128.123 106.387 124.422 107.87C120.722 109.353 112.032 116.74 109.249 128.392C106.476 140.044 103.517 172.578 103.517 172.578C103.517 172.578 104.133 162.302 97.2587 159.024C97.2587 159.024 95.1302 154.828 95.1302 150.202C95.1302 145.577 93.5289 126.353 95.1888 111.744C96.8487 97.1359 98.8893 77.3556 128.67 70.1441C158.45 62.9327 188.611 64.416 195.455 80.3124C195.455 80.3124 202.485 78.4681 202.671 71.6177C202.671 71.6177 204.155 78.2729 198.97 80.488C198.97 80.488 207.485 76.6042 212.103 79.561C212.103 79.561 206.186 78.8194 202.856 81.4053C202.856 81.4053 216.546 83.4351 219.504 93.7887C222.463 104.142 231.27 146.816 222.755 159.57C222.755 159.57 218.02 162.078 217.463 172.549C217.463 172.549 205.805 144.445 205.249 132.061C204.692 119.678 196.002 110.241 185.271 108.953C174.56 107.685 160.5 110.827 160.5 110.827Z",
    fill: "#535F79"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_618_8480"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 66,
    width: 259,
    height: 241,
    rx: 120.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictureicon);
export default __webpack_public_path__ + "static/media/pictureicon.da62e8bd3449133b800b2491eefeb300.svg";
export { ForwardRef as ReactComponent };